import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {FixedHeightLabels} from '../../FixedHeightLabels';
import {TextBuiltInControl} from '../TextBuiltInControl';

export abstract class TextFixedHeightBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_TEXT].FIXED_HEIGHT;
  }

  public getLabels(): FixedHeightLabels | undefined {
    return undefined;
  }
}
